module.exports = __webpack_public_path__ + "static/Bloktopia-e552e5d6b076411ddc61f7059f9672eb.png";